import { ImagePage } from "types";

export default {
  type: "imagePage",
  url: "assets/images/showPages/line-of-duty-showpage.jpg",
} as ImagePage;
